<template>
  <v-row dense >
    <v-col>
      <v-row dense>
                <span
                  test-id="transaction-digital-signature-info"
                  class="text-uppercase cts-color-tertiary">{{$vuetify.lang.t('$vuetify.transactionDigitalSignatureInfo')}}</span>
      </v-row>
      <v-row dense> 
        <v-col cols="12" md="4">
          <v-list-item class="transaction-digital-card" test-id="transaction-digital-signature-type"> 
            <v-list-item-avatar>
              <v-icon color="var(--primary)">
                {{transaction_content.parameters.find(param => param.key === 'signature_type').value === 'face-to-face' ? 'mdi-account' : 'send'}}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title test-id="transaction-digital-signature-type-title">{{$vuetify.lang.t('$vuetify.signatureType')}}</v-list-item-title>
              <v-list-item-subtitle test-id="transaction-digital-signature-type-subtitle">
                <span
                  v-if="transaction_content.parameters.find(param => param.key === 'signature_type').value === 'face-to-face'">
                  {{$vuetify.lang.t('$vuetify.faceToFace')}}
                </span>
                <span v-else>
                  {{$vuetify.lang.t('$vuetify.remote')}}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
          <v-list-item class="transaction-digital-card" test-id="transaction-digital-signature-expiration">
            <v-list-item-avatar>
              <v-icon color="var(--primary)" test-id="transaction-digital-signature-icon">mdi-calendar</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title test-id="transaction-digital-signature-expiration-title">
                {{ $vuetify.lang.t('$vuetify.expiration') }}
              </v-list-item-title>

              <v-list-item-subtitle  test-id="transaction-digital-signature-expiration-subtitle">
                <span v-if="signatureCreationError">
                  {{$vuetify.lang.t('$vuetify.notAvailable')}}
                </span>
               <span v-else>
                  <span v-if="dayjs(expirationTimestamp).isBefore(dayjs())" class="text-ellipsis">
                    {{$vuetify.lang.t('$vuetify.expired')}}
                  </span>

                  <span v-if="transactionIsCancelled">
                    {{$vuetify.lang.t('$vuetify.transaction_cancelled')}}
                  </span>

                  <span v-else-if="intervenersProgress === interversWithActions">
                    {{$vuetify.lang.t('$vuetify.notApplicable')}}
                  </span>

                  <span v-else style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    {{ dayjs(expirationTimestamp).format(const_global.DATE_TIME_FORMAT_B) }}
                    ({{ dayjs(expirationTimestamp).fromNow() }})
                  </span>
               </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
          <v-list-item class="transaction-digital-card">
            <v-list-item-avatar>
              <v-icon color="var(--primary)">people</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                {{ $vuetify.lang.t('$vuetify.signatureStatus') }}
              </v-list-item-title>

              <v-list-item-subtitle v-if="signatureCreationError">
                {{$vuetify.lang.t('$vuetify.notAvailable')}}
              </v-list-item-subtitle>

              <v-list-item-subtitle v-else>
                <span v-if="intervenersProgress === interversWithActions">
                  {{$vuetify.lang.t('$vuetify.completed')}}
                </span>

                <span v-else-if="transactionIsExpired">
                  {{ $vuetify.lang.t('$vuetify.notApplicable') }}
                </span>

                <span v-else-if="transactionIsCancelled">
                  {{ $vuetify.lang.t('$vuetify.transaction_cancelled') }}
                </span>

                <span v-else>
                  {{ interversWithActions - intervenersProgress}}
                  {{$vuetify.lang.t('$vuetify.remaining')}}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script lang="js">
import dayjs from "../../../../../plugins/dayjs";
import const_global from "@/constants/global";

export default {
  name: "TransactionSectionDigitalSignature",
  props: {
    transaction_content: Object
  },
  data() {
    return {
      const_global
    }
  },
  computed: {
    expirationTimestamp() {
      const creationTimestamp = dayjs(this.transaction_content.creation_timestamp * 1000);
      const daysToExpire = parseInt(this.transaction_content.parameters.find(param => param.key === "expiration").value);

      return (creationTimestamp.add(daysToExpire, 'day'))
    },
    reminders() {
      const emails = this.transaction_content.parameters.find(param => param.key === "communications_email")
      const sms = this.transaction_content.parameters.find(param => param.key === "communications_sms")

      return {
        emails: emails && emails.value ? emails.value.length - 1 : [],
        sms: sms && emails.value ? sms.value.length - 1 : []
      }
    },
    signatureCreationError() {
      return this.transaction_content.events.find(e => e.key === "front_renderer_builder.transaction_invalid") !== undefined
    },

    interversWithActions() {
      const creationEvent = this.transaction_content.events
        .find(e => e.key === "front_renderer_builder.transaction_created");

      if (creationEvent) {
        const { subtitle } = creationEvent

        const match = subtitle.match(/Interveners:\s(\d+)/);
        if (match) {
          const nOfInterveners = parseInt(match[1]);
          
          return nOfInterveners
        }
      }

      return 1
    },

    intervenersProgress() {
      return this.transaction_content.events
        .filter(event => event.key === "front_renderer_builder.intervener_finished").length
    },

    transactionIsCancelled() {
      return this.transaction_content.events
        .find(e => e.key === "TRANSACTION.canceled") !== undefined
    },

    transactionIsExpired() {
      return this.transaction_content.events
        .find(e => e.key === "front_renderer_builder.transaction_expired") !== undefined
    }
  },
  methods: {
    dayjs,

  }
}
</script>


<style lang="scss">
.transaction-digital-card {
  border: solid 1px var(--card-border);
  border-radius: 4px;

  .v-list-item-content {
    min-width: 0;
  }

  .v-list-item-subtitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>